//
//
//
//
//
//
//
//
//
//
//
//

export default {

  data() {
    return {
      //sports: []
    }
  },
  computed: {
    sports() {
      let sports = this._.get(this.$store.state, 'sports', []);
      //sports = _.filter(sports);
      sports = this._.filter(sports, function(o) {
        if(o.category == 'sport' && o.event_count+o.outright_count > 0) {
          return o
        }
        if(o.is_parent) {
          return o
        }
        return false
      });

      return sports
    }
  },
  filters: {

  },
  mounted() {},
  methods: {
    getURL: function (sport) {
      if (sport.event_count > 0 || sport.is_parent) {
        return this.localePath('/' + sport.translated_slug + '/')
      }
      return this.localePath('/' + sport.translated_slug + '/')
    }
  }
}
